import { createFileRoute } from "@tanstack/react-router";

// The root index route renders nothing — the WorkspaceGuard in __root.tsx
// handles the redirect to /{workspace-slug}/inbox or /onboarding.
export const Route = createFileRoute("/")({
  component: () => null,
});
